const attestationMixin = {
    data() {
        return {
            RESOURCE_POST_ID: 13,
            RESOURCE_POSITION_ATTESTATION_ID: 17,
        }
    },
}

export default attestationMixin;
